import {capitalize, useTheme} from '@mui/material';

import {BookingTypeEnum} from 'presentation/pages/private/booking/constants';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {useMonitoringTime} from 'presentation/pages/private/hooks/useMonitoringTime';
import {getFlowTypeByBookingType} from 'presentation/utils';

import {useBookingTheme} from 'presentation/modules/booking/shared/hooks/useBookingTheme';
import {AppointmentsHomeStateType} from 'presentation/pages/private/home/types';
import {buildContentList} from '../../utils/buildContentList';
import {getAppointmentClinicName} from 'presentation/modules/myAppointments/utils/getAppointmentClinicName';
import {isAdvanceDiagnosticsAppointment} from 'presentation/modules/myAppointments/utils/isAdvanceDiagnosticsAppointment';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {FeaturesEnum} from 'presentation/constants';

export function useAppointmentCard(appointment: AppointmentsHomeStateType) {
	const {palette, colors} = useTheme();
	const {isLaptop} = useMediaQueries();
	const {iconName, bookingType} = useBookingTheme({
		flowType: getFlowTypeByBookingType(appointment.bookingType),
	});
	const {goToTelehealthAvailability, hourStringFormatted} = useMonitoringTime(
		appointment?.dateUtc ?? appointment.date,
	);

	const {isEnabled: isUploadFileTeleFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_UPLOAD_FILE_TELE,
	);
	const {isEnabled: isAdvanceDiagnosticsExamsJourneyEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_PPO_ADVANCE_DIAGNOSTICS_EXAMS_JOURNEY,
	);

	const isTelehealth = appointment.bookingType === BookingTypeEnum.TELEHEALTH;
	const isOdonto = appointment.bookingType === BookingTypeEnum.ODONTO;
	const isHealth = appointment.bookingType === BookingTypeEnum.HEALTH;
	const showEnterRoom = isTelehealth && goToTelehealthAvailability;

	const appointmentDateString = `${capitalize(appointment.formattedDateWithWeekday)} às ${isTelehealth ? hourStringFormatted : appointment.hour}`;

	const CONTENT_LIST = buildContentList({
		palette,
		colors,
		appointment,
		bookingType,
	});

	const hideFavoriteButton = !(isHealth || isTelehealth);

	const clinicName = getAppointmentClinicName({
		appointment,
		isAdvanceDiagnosticsExamsJourneyEnabled,
	});

	const isAdvanceDiagnosticsExam = isAdvanceDiagnosticsAppointment({
		appointment,
		isAdvanceDiagnosticsExamsJourneyEnabled,
	});

	return {
		palette,
		colors,
		isLaptop,
		iconName,
		bookingType,
		isTelehealth,
		showEnterRoom,
		appointmentDateString,
		CONTENT_LIST,
		isUploadFileTeleFeatureFlagEnabled,
		isOdonto,
		hideFavoriteButton,
		clinicName,
		isAdvanceDiagnosticsExam,
	};
}
